import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';

import type {
  Action,
  Dispatch,
  StatisticsCommon,
  ThunkAction
} from 'types';

const { LISTS, SUBCAMPAIGNS } = API.END_POINTS;

const AUDIENCE_OVERLAP_LOADED = 'statistics/AUDIENCE_OVERLAP_LOADED';
const AUDIENCE_OVERLAP_RESET = 'statistics/AUDIENCE_OVERLAP_RESET';
const SET_AUDIENCE_OVERLAP_STATUS = 'statistics/SET_AUDIENCE_OVERLAP_STATUS';

export const AUDIENCE_OVERLAP_STATUSES = {
  LOADING: 'loading',
  AVAILABLE: 'available',
  NOT_AVAILABLE: 'general_service_error'
};


const initialState = {
  overlap: [],
  overlapStatus: AUDIENCE_OVERLAP_STATUSES.LOADING
};

const audienceOverlapLoaded = (overlap: Array<StatisticsCommon>): Action => ({
  type: AUDIENCE_OVERLAP_LOADED,

  payload: {
    overlap
  }
});

export const resetAudienceOverlap = (): Action => ({
  type: AUDIENCE_OVERLAP_RESET
});

const setOverlapStatus = (status: string): Action => ({
  type: SET_AUDIENCE_OVERLAP_STATUS,

  payload: {
    status
  }
});

const fetchAudienceOverlap = (url: string): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(setOverlapStatus(AUDIENCE_OVERLAP_STATUSES.LOADING));

  try {
    const response = await get(url, undefined, { suppressGlobalNotification: true });
    const overlap = response.data || [];

    dispatch(audienceOverlapLoaded(overlap));
  } catch (e) {
    if (e.response?.data?.code) {
      dispatch(setOverlapStatus(e.response.data.code));
    } else {
      // unknown error occured
      dispatch(setOverlapStatus(AUDIENCE_OVERLAP_STATUSES.NOT_AVAILABLE));
    }

    logError(e);
  }
};

export const fetchAudienceOverlapCampaign = (campaignId: number, offerState: string): ThunkAction => fetchAudienceOverlap(SUBCAMPAIGNS.getAudienceOverlap(campaignId, offerState));

export const fetchAudienceOverlapLists = (orgId: number, listId: number): ThunkAction => fetchAudienceOverlap(LISTS.getAudienceOverlap(orgId, listId));

export default createReducer<any, any>('statisticsAudienceOverlap', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [SET_AUDIENCE_OVERLAP_STATUS]: (state, { status }) => ({
    ...state,
    overlapStatus: status
  }),
  [AUDIENCE_OVERLAP_LOADED]: (state, { overlap }) => ({
    ...state,
    overlap,
    overlapStatus: AUDIENCE_OVERLAP_STATUSES.AVAILABLE
  }),
  [AUDIENCE_OVERLAP_RESET]: (state) => ({
    ...state,
    overlap: [],
    overlapStatus: AUDIENCE_OVERLAP_STATUSES.LOADING
  })
});
